if (!window.beegivCartImagePreviewReady) {
  window.beegivCartImagePreviewReady = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-cart-image-preview-open]');
    if (trigger) {
      document.getElementById(trigger.getAttribute('aria-controls'))?.showModal();
      return;
    }

    const dialog = event.target.closest('[data-cart-image-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });
}
